import { Link } from 'react-router-dom';
import { Briefcase, Mail, Facebook, Instagram } from 'lucide-react';
import NewsletterForm from './NewsletterForm';

const Footer = () => {
  const openCookieSettings = () => {
    // Clear cookie consent to show banner again
    localStorage.removeItem('cookieConsent');
    window.location.reload();
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo y Descripción */}
          <div className="col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <Briefcase className="w-7 h-7 text-emerald-400" />
              <span className="text-xl font-bold">JobSuiza</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Tu plataforma de búsqueda de empleo en Suiza para hispanohablantes. 
              Encuentra trabajos que requieren español.
            </p>
            {/* Social Media */}
            <div className="flex space-x-3">
              <a 
                href="https://www.facebook.com/jobsuizaoficial" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-blue-600 hover:bg-blue-700 rounded-full transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/jobsuizaoficial" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 hover:from-purple-700 hover:via-pink-600 hover:to-orange-500 rounded-full transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/ofertas" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Buscar Empleos
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/anuncios" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Tablón de Anuncios
                </Link>
              </li>
              <li>
                <Link to="/quienes-somos" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Quiénes Somos
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Política de Cookies
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-emerald-400 text-sm transition-colors">
                  Términos y Condiciones
                </Link>
              </li>
              <li>
                <button 
                  onClick={openCookieSettings}
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors text-left"
                >
                  Configuración de Cookies
                </button>
              </li>
            </ul>
          </div>

          {/* Newsletter y Contacto */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Newsletter</h3>
            <NewsletterForm variant="footer" />
            
            <h3 className="font-semibold text-lg mt-6 mb-3">Contacto</h3>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2 text-sm text-slate-400">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@jobsuiza.com" className="hover:text-emerald-400 transition-colors">
                  info@jobsuiza.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divisor */}
        <div className="border-t border-slate-800 mt-8 pt-8">
          <div className="text-center">
            <p className="text-slate-400 text-sm">
              © {currentYear} JobSuiza. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
